import { lockDispatch, unlockDispatch } from "./devDispatchLockerService";
import { isDebugSession } from "./isFunctions";
import { compose, Func0 } from "redux";
import { getFrom } from "../services/propertyGetter/propertyGetter";
import { IDynamicPartsContainer } from "../../modules/appCore/pagesDeclarationBuilder/model";

export function beforeAll() {
    if (isDebugSession())
        lockDispatch();
}

export function afterAll<T extends IDynamicPartsContainer>(getState: Func0<T>) {
    if (isDebugSession()) {
        const state = getState();
        const activePartName = getFrom(state, s => s["@dynamicReducer"].activePartName);
        unlockDispatch(!activePartName); // todo: investigate how to figure out is redispatch needed in debugSession
    }
}


export function getCompose() {
    const reduxCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    return reduxCompose
        ? reduxCompose({
            //trace: true
        }) :
        compose;
}